import { ChainId, JSBI, Percent, Token, WETH } from '@uniswap/sdk'
import { AbstractConnector } from '@web3-react/abstract-connector'

import { fortmatic, injected, portis, walletconnect, walletlink } from '../connectors'

export const ROUTER_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
  [ChainId.ROPSTEN]: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
  [ChainId.RINKEBY]: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
  [ChainId.BSC]: '0x10ED43C718714eb63d5aA57B78B54704E256024E',
  [ChainId.FANTOM]: '0xF491e7B69E4244ad4002BC14e878a34207E38c29',
  [ChainId.AVALANCHE]: '0xE54Ca86531e17Ef3616d22Ca28b0D458b6C89106'
}

export const ANTIMATTER_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x60d0769c4940cA58648C0AA34ecdf390a10F272e',
  [ChainId.ROPSTEN]: '0x60d0769c4940cA58648C0AA34ecdf390a10F272e',
  [ChainId.RINKEBY]: '0x60d0769c4940cA58648C0AA34ecdf390a10F272e',
  [ChainId.BSC]: '0x60d0769c4940cA58648C0AA34ecdf390a10F272e',
  [ChainId.FANTOM]: '',
  [ChainId.AVALANCHE]: ''
}

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

// a list of tokens by chain
type ChainTokenList = {
  readonly [chainId in ChainId]: Token[]
}

const UNI_ADDRESS = '0x9B99CcA871Be05119B2012fd4474731dd653FEBe'

export const Matter = new Token(ChainId.MAINNET, UNI_ADDRESS, 18, 'MATTER', 'Antimatter.Finance Governance Token')
export const DAI = new Token(ChainId.MAINNET, '0x6B175474E89094C44Da98b954EedeAC495271d0F', 18, 'DAI', 'Dai Stablecoin')
export const USDC = new Token(ChainId.MAINNET, '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', 6, 'USDC', 'USD//C')
export const USDT = new Token(ChainId.MAINNET, '0xdAC17F958D2ee523a2206206994597C13D831ec7', 6, 'USDT', 'Tether USD')
export const COMP = new Token(ChainId.MAINNET, '0xc00e94Cb662C3520282E6f5717214004A7f26888', 18, 'COMP', 'Compound')
export const MKR = new Token(ChainId.MAINNET, '0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2', 18, 'MKR', 'Maker')
export const AMPL = new Token(ChainId.MAINNET, '0xD46bA6D942050d489DBd938a2C909A5d5039A161', 9, 'AMPL', 'Ampleforth')
export const WBTC = new Token(ChainId.MAINNET, '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599', 8, 'WBTC', 'Wrapped BTC')

export const ETH_CALL = new Token(
  ChainId.MAINNET,
  '0x3843a61f2960108287A51806c683fc854dC00354',
  18,
  '+ETH($1000)',
  'AntiMatter.Finance ETH Perpetual Call Option Floor $1000 Cap $3000'
)
export const ETH_PUT = new Token(
  ChainId.MAINNET,
  '0xfE41168Fe09359c4b010E414c724c643dF4159A3',
  18,
  '-ETH($3000)',
  'AntiMatter.Finance ETH Perpetual Put Option Floor $1000 Cap $3000'
)
export const MATTER_CALL = new Token(
  ChainId.MAINNET,
  '0xD5eE7F431fFB7F03a19CFAE69A1E75a450Ec2021',
  18,
  '+MATTER($1)',
  'AntiMatter.Finance MATTER Perpetual Call Option Floor $1 Cap $100'
)

// Block time here is slightly higher (~1s) than average in order to avoid ongoing proposals past the displayed time
export const AVERAGE_BLOCK_TIME_IN_SECS = 13
export const PROPOSAL_LENGTH_IN_BLOCKS = 40_320
export const PROPOSAL_LENGTH_IN_SECS = AVERAGE_BLOCK_TIME_IN_SECS * PROPOSAL_LENGTH_IN_BLOCKS

export const FACTORY_CHAIN_ID = 1
export const GOVERNANCE_ADDRESS = '0xDf7d362D1E3e5Db29C0B0A1ae75064523C2B2D9f'

// chain 3
// export const INDEX_NFT_ADDRESS = '0x53E416C1Bd19bAA9EE334061d900f58A12BB64e4'
// export const MATTER_ADDRESS = '0x1C9491865a1DE77C5b6e19d2E6a5F1D7a6F2b25F'

// chain 1
export const INDEX_NFT_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xD12D12AaCad77D54421A2c2AD723e259Bf390488',
  [ChainId.ROPSTEN]: '0x53E416C1Bd19bAA9EE334061d900f58A12BB64e4',
  [ChainId.RINKEBY]: '',
  [ChainId.BSC]: '0x6d31E526208c423C29e021282b3F0fE13EF9d064',
  [ChainId.FANTOM]: '0x59B477e7A08f44BFf4523d153bCcB600681b03e9',
  [ChainId.AVALANCHE]: '0xf56a61A65b2ba9d8f2A28f16304d6a63B46Fe2C6'
}
export const LOCKER_721_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xD0dAe06f83c3a1f86bC670DBDB6F74dE563424f8',
  [ChainId.ROPSTEN]: '0x3e8c5D4540eC1A3baeBB5671387906Caf14CaFeb',
  [ChainId.RINKEBY]: '0x49db762E1bF8240218E03Ba989499bE1aCD20784',
  [ChainId.BSC]: '0x08A9c8E8EC6fE2633c488F9F60960aEd4DA60c47',
  [ChainId.FANTOM]: '0xD12D12AaCad77D54421A2c2AD723e259Bf390488',
  [ChainId.AVALANCHE]: '0xD12D12AaCad77D54421A2c2AD723e259Bf390488'
}
export const CHAIN_ETH_NAME: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: 'ETH',
  [ChainId.ROPSTEN]: 'ETH',
  [ChainId.RINKEBY]: 'ETH',
  [ChainId.BSC]: 'BNB',
  [ChainId.FANTOM]: 'FTM',
  [ChainId.AVALANCHE]: 'AVAX'
}

export const BLIND_BOX_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x05739eB0B2e3F4545a6EFacABAdc85dB2DE730FD',
  [ChainId.ROPSTEN]: '',
  [ChainId.RINKEBY]: '0x3ff9C28cce2805Dd69eec2113a6853d4F49976A8',
  [ChainId.BSC]: '',
  [ChainId.FANTOM]: '',
  [ChainId.AVALANCHE]: ''
}
export const MATTER_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x9B99CcA871Be05119B2012fd4474731dd653FEBe',
  [ChainId.ROPSTEN]: '',
  [ChainId.RINKEBY]: '0x3b557E654b64D57634BfF210E9dc0e64053CddBf',
  [ChainId.BSC]: '',
  [ChainId.FANTOM]: '',
  [ChainId.AVALANCHE]: ''
}
export const INDEX_NFT_BUY_FEE = '5000000000000000'

export const TOKEN_FLUIDITY_LIMIT = 5

// export const FACTORY_CHAIN_ID = 3
// export const GOVERNANCE_ADDRESS = '0x78fC5460737EB07Ce9e7d954B294ecA7E6203D19'
// export const MATTER_ADDRESS = '0x6669Ee1e6612E1B43eAC84d4CB9a94Af0A98E740'

export const GOVERNANCE_TOKEN = new Token(ChainId.MAINNET, MATTER_ADDRESS[1], 18, 'MAT', 'Mat')

export const TIMELOCK_ADDRESS = '0x1a9C8182C09F50C8318d769245beA52c32BE35BC'

export const UNI: { [chainId in ChainId]: Token } = {
  [ChainId.MAINNET]: new Token(ChainId.MAINNET, UNI_ADDRESS, 18, 'MATTER', 'Matter'),
  [ChainId.ROPSTEN]: new Token(ChainId.ROPSTEN, UNI_ADDRESS, 18, 'MATTER', 'Matter'),
  [ChainId.RINKEBY]: new Token(ChainId.RINKEBY, UNI_ADDRESS, 18, 'MATTER', 'Matter'),
  [ChainId.BSC]: new Token(ChainId.BSC, UNI_ADDRESS, 18, 'MATTER', 'Matter'),
  [ChainId.FANTOM]: new Token(ChainId.FANTOM, UNI_ADDRESS, 18, 'MATTER', 'Matter'),
  [ChainId.AVALANCHE]: new Token(ChainId.AVALANCHE, UNI_ADDRESS, 18, 'MATTER', 'Matter')
}

export const COMMON_CONTRACT_NAMES: { [address: string]: string } = {
  [UNI_ADDRESS]: 'UNI1',
  [GOVERNANCE_ADDRESS]: 'Governance',
  [TIMELOCK_ADDRESS]: 'Timelock'
}

// TODO: specify merkle distributor for mainnet
export const MERKLE_DISTRIBUTOR_ADDRESS: { [chainId in ChainId]?: string } = {
  [ChainId.MAINNET]: '0x090D4613473dEE047c3f2706764f49E0821D256e'
}

const WETH_ONLY: ChainTokenList = {
  [ChainId.MAINNET]: [WETH[ChainId.MAINNET]],
  [ChainId.ROPSTEN]: [WETH[ChainId.ROPSTEN]],
  [ChainId.RINKEBY]: [WETH[ChainId.RINKEBY]],
  [ChainId.BSC]: [WETH[ChainId.BSC]],
  [ChainId.FANTOM]: [WETH[ChainId.FANTOM]],
  [ChainId.AVALANCHE]: [WETH[ChainId.AVALANCHE]]
}

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  ...WETH_ONLY,
  [ChainId.MAINNET]: [...WETH_ONLY[ChainId.MAINNET], DAI, USDC, USDT, COMP, MKR, WBTC]
}

/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 */
export const CUSTOM_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
  [ChainId.MAINNET]: {
    [AMPL.address]: [DAI, WETH[ChainId.MAINNET]]
  }
}

// used for display in the default list when adding liquidity
export const SUGGESTED_BASES: ChainTokenList = {
  ...WETH_ONLY,
  [ChainId.MAINNET]: [...WETH_ONLY[ChainId.MAINNET], DAI, USDC, USDT, WBTC]
}

export interface WalletInfo {
  connector?: AbstractConnector
  name: string
  iconName: string
  description: string
  href: string | null
  color: string
  primary?: true
  mobile?: true
  mobileOnly?: true
}

export const SUPPORTED_WALLETS: { [key: string]: WalletInfo } = {
  INJECTED: {
    connector: injected,
    name: 'Injected',
    iconName: 'arrow-right.svg',
    description: 'Injected web3 provider.',
    href: null,
    color: '#010101',
    primary: true
  },
  METAMASK: {
    connector: injected,
    name: 'MetaMask',
    iconName: 'metamask.png',
    description: 'Easy-to-use browser extension.',
    href: null,
    color: '#E8831D'
  },
  WALLET_CONNECT: {
    connector: walletconnect,
    name: 'WalletConnect',
    iconName: 'walletConnectIcon.svg',
    description: 'Connect to Trust Wallet, Rainbow Wallet and more...',
    href: null,
    color: '#4196FC',
    mobile: true
  },
  WALLET_LINK: {
    connector: walletlink,
    name: 'Coinbase Wallet',
    iconName: 'coinbaseWalletIcon.svg',
    description: 'Use Coinbase Wallet app on mobile device',
    href: null,
    color: '#315CF5'
  },
  COINBASE_LINK: {
    name: 'Open in Coinbase Wallet',
    iconName: 'coinbaseWalletIcon.svg',
    description: 'Open in Coinbase Wallet app.',
    href: 'https://go.cb-w.com/mtUDhEZPy1',
    color: '#315CF5',
    mobile: true,
    mobileOnly: true
  },
  FORTMATIC: {
    connector: fortmatic,
    name: 'Fortmatic',
    iconName: 'fortmaticIcon.png',
    description: 'Login using Fortmatic hosted wallet',
    href: null,
    color: '#6748FF',
    mobile: true
  },
  Portis: {
    connector: portis,
    name: 'Portis',
    iconName: 'portisIcon.png',
    description: 'Login using Portis hosted wallet',
    href: null,
    color: '#4A6C9B',
    mobile: true
  }
}

export const NetworkContextName = 'NETWORK'

// default allowed slippage, in bips
export const INITIAL_ALLOWED_SLIPPAGE = 50
// 20 minutes, denominated in seconds
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 20

// used for rewards deadlines
export const BIG_INT_SECONDS_IN_WEEK = JSBI.BigInt(60 * 60 * 24 * 7)

export const BIG_INT_ZERO = JSBI.BigInt(0)

// one basis point
export const ONE_BIPS = new Percent(JSBI.BigInt(1), JSBI.BigInt(10000))
export const BIPS_BASE = JSBI.BigInt(10000)
// used for warning states
export const ALLOWED_PRICE_IMPACT_LOW: Percent = new Percent(JSBI.BigInt(100), BIPS_BASE) // 1%
export const ALLOWED_PRICE_IMPACT_MEDIUM: Percent = new Percent(JSBI.BigInt(300), BIPS_BASE) // 3%
export const ALLOWED_PRICE_IMPACT_HIGH: Percent = new Percent(JSBI.BigInt(500), BIPS_BASE) // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
export const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN: Percent = new Percent(JSBI.BigInt(1000), BIPS_BASE) // 10%
// for non expert mode disable swaps above this
export const BLOCKED_PRICE_IMPACT_NON_EXPERT: Percent = new Percent(JSBI.BigInt(1500), BIPS_BASE) // 15%

// used to ensure the user doesn't send so much ETH so they end up with <.01
export const MIN_ETH: JSBI = JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(16)) // .01 ETH
export const BETTER_TRADE_LESS_HOPS_THRESHOLD = new Percent(JSBI.BigInt(50), JSBI.BigInt(10000))

export const ZERO_PERCENT = new Percent('0')
export const ONE_HUNDRED_PERCENT = new Percent('1')

// SDN OFAC addresses
export const BLOCKED_ADDRESSES: string[] = [
  '0x7F367cC41522cE07553e823bf3be79A889DEbe1B',
  '0xd882cFc20F52f2599D84b8e8D58C7FB62cfE344b',
  '0x901bb9583b24D97e995513C6778dc6888AB6870e',
  '0xA7e5d5A720f06526557c513402f2e6B5fA20b008',
  '0x8576aCC5C05D6Ce88f4e49bf65BdF0C62F91353C'
]
